import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

//    Styled Table Cell

export const StyledTableCell = styled(TableCell)(() => ({
    padding: '0px !important',
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#3665ff',
        color: '#fff',
        fontSize: 15,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 15,
        border: 'none',
    },
}));


//    Styled Table Row

export const StyledTableRow = styled(TableRow)(() => ({
    '&:nth-of-type(even)': {
        backgroundColor: '#3665ff0d',
        border: 'none',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 'none',
    },
    // Hover effect
    '&:hover': {
        backgroundColor: '#3665ff0d',
        cursor: 'pointer',
    },
}));
